import { 
  GoogleAuthProvider, 
  FacebookAuthProvider, 
  OAuthProvider,
  signInWithPopup,
  browserLocalPersistence,
  setPersistence
} from 'firebase/auth';
import { auth } from '../config/firebase';

class AuthService {
  constructor() {
    this.auth = auth;
    this.translations = {
      errors: {
        loginCancelled: {
          en: 'Login cancelled - Please try again',
          ar: 'تم إلغاء تسجيل الدخول - يرجى المحاولة مرة أخرى'
        },
        popupBlocked: {
          en: 'Popup blocked - Please allow popups for this website',
          ar: 'تم حظر النافذة المنبثقة - يرجى السماح بالنوافذ المنبثقة لهذا الموقع'
        },
        loginInProgress: {
          en: 'Another login is in progress',
          ar: 'هناك عملية تسجيل دخول أخرى قيد التنفيذ'
        },
        unauthorizedDomain: {
          en: 'This domain is not authorized for login',
          ar: 'هذا النطاق غير مصرح به لتسجيل الدخول'
        },
        invalidProvider: {
          en: 'Invalid provider',
          ar: 'مزود غير صالح'
        }
      }
    };
  }

  getProvider(providerName) {
    console.log(`Getting provider for: ${providerName}`);
    
    switch (providerName) {
      case 'google': {
        const provider = new GoogleAuthProvider();
        provider.addScope('email');
        provider.addScope('profile');
        return provider;
      }
      case 'facebook': {
        const provider = new FacebookAuthProvider();
        provider.addScope('email');
        provider.addScope('public_profile');
        return provider;
      }
      case 'microsoft': {
        const provider = new OAuthProvider('microsoft.com');
        provider.setCustomParameters({
          prompt: 'select_account'
        });
        return provider;
      }
      default:
        const language = parseInt(localStorage.getItem('language')) === 1 ? 'en' : 'ar';
        throw new Error(this.translations.errors.invalidProvider[language]);
    }
  }

  async socialLogin(providerName) {
    console.log(`Starting social login with ${providerName}`);
    const language = parseInt(localStorage.getItem('language')) === 1 ? 'en' : 'ar';
    
    try {
      await setPersistence(this.auth, browserLocalPersistence);
      const provider = this.getProvider(providerName);
      console.log('Provider configured:', provider);

      if (provider instanceof GoogleAuthProvider || provider instanceof FacebookAuthProvider) {
        provider.setCustomParameters({
          prompt: 'select_account',
          display: 'popup'
        });
      }

      const result = await signInWithPopup(this.auth, provider);
      console.log('Auth result:', result);
      return result;
      
    } catch (error) {
      console.error('Social login error:', error);
      
      // Handle specific error cases with translations
      switch (error.code) {
        case 'auth/popup-closed-by-user':
          throw new Error(this.translations.errors.loginCancelled[language]);
        case 'auth/popup-blocked':
          throw new Error(this.translations.errors.popupBlocked[language]);
        case 'auth/cancelled-popup-request':
          throw new Error(this.translations.errors.loginInProgress[language]);
        case 'auth/unauthorized-domain':
          throw new Error(this.translations.errors.unauthorizedDomain[language]);
        default:
          throw error;
      }
    }
  }
}

export const authService = new AuthService(); 